module.exports = __webpack_public_path__ + "static/media/jeton_small.478ba87f.svg";